import { AutomationEventTypes } from "../AutomationModuleTypes";
import _ from "lodash";

const vt = {
    STRING: "string",
    NUMBER: "number", 
    BOOLEAN: "boolean",
    DATE: "date",
    DATETIME: "datetime",
    TIME: "time",
    ENUM: "enum",
    ARRAY: "array",
    ARRAY_NUMBER: "array_number",
    ARRAY_STRING: "array_string",
    ARRAY_DATE: "array_date",
    ARRAY_OBJECT: "array_objectId",
    ARRAY_BOOLEAN: "array_boolean",
    OBJECT: "object",
    MIXED: "mixed",
};

const contexts = {
    CONTACT: "contact",
    CONVERSATION: "conversation",
    BLOCK: "block",
    EVENT: "event",
    WEBHOOK: "webhook",
    SYSTEM: "system",
    CUSTOM: "custom",
};

const defaultOperators = {
    string: [
        "equal",
        "not_equal",
        "contains",
        "not_contains",
        "empty",
        "not_empty",
        "starts_with",
        "ends_with",
        "shorter_than",
        "longer_than",
    ],
    array: ["equal", "not_equal", "contains", "not_contains", "empty", "not_empty"],
    number: ["equal", "not_equal", "greater_than", "less_than", "greater_than_or_equal", "less_than_or_equal"],
    boolean: ["equal", "not_equal", "empty", "not_empty"],
    date: [
        "equal",
        "not_equal",
        "greater_than",
        "less_than",
        "greater_than_or_equal",
        "less_than_or_equal",
        "empty",
        "not_empty",
    ],
    ObjectId: ["equal", "not_equal", "empty", "not_empty"],
    object: ["equal", "not_equal", "empty", "not_empty"],
    mixed: [
        "equal",
        "not_equal",
        "contains",
        "not_contains",
        "empty",
        "not_empty",
        "starts_with",
        "ends_with",
        "shorter_than",
        "longer_than",
        "greater_than",
        "less_than",
        "greater_than_or_equal",
        "less_than_or_equal",
    ],
};

const ga = (
    context,
    value,
    label,
    valueType = "string",
    controlType = "input",
    subAttributes = [],
    defaultFilterValue = undefined,
    defaultOperator = undefined,
    availableOperators = undefined,
    options = undefined
) => {
    return {
        context,
        name,
        value,
        label,
        defaultOperator: defaultOperator || "equal",
        defaultFilterValue,
        availableOperators: availableOperators || defaultOperators[valueType] || ["equal", "not_equal"],
        controlType,
        options,
        subAttributes,
        valueType,
    };
};

class ChannelModuleAttributeFactory {
    /**
     * @param parent {AutomationAttributesGenerator}
     */
    constructor(parent) {
        this.parent = parent;
    }

    generate() {
        return _.concat(
            this.channelStatusChanged(),
            this.channelDisconnected()
        );
    }

    channelStatusChanged() {
        const e = AutomationEventTypes.CHANNEL.STATUS_CHANGED;
        const context = contexts.EVENT;
        const prefix = `event.${e}`;

        return [
            ga(context, prefix, "Kanal Bağlantı Durumu Değişti", vt.OBJECT, undefined, [
                ga(context, `${prefix}.$..*`, "*", vt.OBJECT),
                ga(context, `${prefix}.siteId`, "Site ID", vt.STRING),
                ga(context, `${prefix}.channelId`, "Kanal ID", vt.STRING),
                ga(context, `${prefix}.oldStatus`, "Eski Durum", vt.STRING, "select", undefined, undefined, undefined, undefined, [
                    { value: "OK", label: "Bağlı" },
                    { value: "ERROR", label: "Hata" },
                    { value: "STOPPED", label: "Durduruldu" },
                    { value: "CREDENTIALS", label: "Kimlik Doğrulama Gerekli" },
                    { value: "CONNECTING", label: "Bağlanıyor" },
                ]),
                ga(context, `${prefix}.newStatus`, "Yeni Durum", vt.STRING, "select", undefined, undefined, undefined, undefined, [
                    { value: "OK", label: "Bağlı" },
                    { value: "ERROR", label: "Hata" },
                    { value: "STOPPED", label: "Durduruldu" },
                    { value: "CREDENTIALS", label: "Kimlik Doğrulama Gerekli" },
                    { value: "CONNECTING", label: "Bağlanıyor" },
                ])
            ])
        ];
    }

    channelDisconnected() {
        const e = AutomationEventTypes.CHANNEL.DISCONNECTED;
        const context = contexts.EVENT;
        const prefix = `event.${e}`;

        return [
            ga(context, prefix, "Kanal Bağlantısı Koptu", vt.OBJECT, undefined, [
                ga(context, `${prefix}.$..*`, "*", vt.OBJECT),
                ga(context, `${prefix}.siteId`, "Site ID", vt.STRING),
                ga(context, `${prefix}.channelId`, "Kanal ID", vt.STRING),
                ga(context, `${prefix}.oldStatus`, "Eski Durum", vt.STRING),
                ga(context, `${prefix}.newStatus`, "Yeni Durum (CREDENTIALS)", vt.STRING)
            ])
        ];
    }
}

export default ChannelModuleAttributeFactory;

